export default {
  isObj(obj) {
    if (Object.prototype.toString.call(obj) === '[object Object]') { 
      return true;
    }
    return false;
  },
  objToStr(obj) {
    if (Object.prototype.toString.call(obj) !== '[object Object]') {
      return '';
    }
    let str = '';
    Object.keys(obj).forEach((key) => {
      str += `${key}=${encodeURIComponent(obj[key])}&`;
    });
    return str.substr(0, str.length - 1);
  },
  isObjEmpty(obj) {
    const isObjFlag = this.isObj(obj);
    let flag = true;
    if (isObjFlag) {
      const arr = Object.keys(obj);
      if (arr.length > 0) {
        flag = false;
      }
    }
    return flag;
  },
};

